"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-teodoro-ss": {
    "81c7a146": [{
      "hkey": "5fedd171",
      "slug": "capo-di-coda-cavallo-cala-suaraccia-salina-bamba",
      "name": "Capo di Coda Cavallo-Cala Suaraccia-Salina Bamba",
      "primary": true,
      "skipSearch": false
    }],
    "capo-di-coda-cavallo": [{
      "hkey": "5fedd171",
      "slug": "capo-di-coda-cavallo-cala-suaraccia-salina-bamba",
      "name": "Capo di Coda Cavallo-Cala Suaraccia-Salina Bamba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "75f43a0e": [{
      "hkey": "d2e27e3b",
      "slug": "san-teodoro-ss",
      "name": "San Teodoro",
      "primary": true,
      "skipSearch": false
    }],
    "costa-dorata": [{
      "hkey": "d2e27e3b",
      "slug": "san-teodoro-ss",
      "name": "San Teodoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f479bd74": [{
      "hkey": "86bbe177",
      "slug": "puntaldia-lu-impostu",
      "name": "Puntaldia-Lu Impostu",
      "primary": true,
      "skipSearch": false
    }],
    "punta-aldia": [{
      "hkey": "86bbe177",
      "slug": "puntaldia-lu-impostu",
      "name": "Puntaldia-Lu Impostu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5a52a897": [{
      "hkey": "2f5297dc",
      "slug": "punta-molara-cala-girgolu",
      "name": "Punta Molara-Cala Girgolu",
      "primary": true,
      "skipSearch": false
    }],
    "punta-molara": [{
      "hkey": "2f5297dc",
      "slug": "punta-molara-cala-girgolu",
      "name": "Punta Molara-Cala Girgolu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;